import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const Container = styled.div`
  display: flex;
  gap: ${token('space.200')};
`;

export const Label = styled.div`
  width: 230px;
  color: ${token('color.text.subtlest')};
  font-weight: 600;
  padding: ${token('space.100')};
  padding-left: 0;
`;

export const Value = styled.div`
  color: ${token('color.text')};
  width: 100%;
  padding: ${token('space.100')};
  padding-left: 0;
`;
